import { ujsAjaxParams } from "./utils";

$(function () {
  var _swapContainers = function () {
    $(".email-container").remove();
    $(".table-container").fadeIn(400);
  };

  var _addAlternateSuccessMessage = function () {
    var successMessage = "Thank you for your email address.";
    $(".output")
      .addClass("has-success")
      .text(successMessage)
      .fadeIn(400);
  };
  var _addErrorMessage = function (xhr) {
    const errorMessage = xhr.responseJSON.message || 'There was an error. Please try again.';
    $(".output").hide().addClass("has-error").text(errorMessage).fadeIn(400);
  };
  var captureEmail = function (email) {
    $(".interactive-lead-capture")
      .on("ajax:success", function (ujsEvent) {
        const { data } = ujsAjaxParams(ujsEvent);
        var eventType = data.existing ? "Existing list lead" : "List lead";

        analytics.identify(data.userID, { call_location: 'list-lead' })
        analytics.track('lead-conversion');

        window['optimizely'] = window['optimizely'] || [];
        window['optimizely'].push({
          type: "event",
          eventName: "lead",
          tags: {
            revenue: 0, // Optional in cents as integer (500 == $5.00)
            value: 0.00 // Optional as float
          }
        });

        ahoy.start();
        ahoy.track(eventType, {
          user_id: data.userID,
          email: data.email,
          page: window.location.pathname
        });

        switch (window.location.pathname) {
          case "/projects/vc-diversity-index":
            _swapContainers();
            break;
          case "/projects/vc-diversity-index-2017":
            _swapContainers();
            break;
          case "/projects/future-list-2016":
            _swapContainers();
            break;
          case "/projects/future-list-2015":
            _swapContainers();
            break;
          case "/insider-list":
            _swapContainers();
            break;
          case "/top-tech-companies-to-hire-from":
            $(".has-fadeout").removeClass("has-fadeout down-up");
            _swapContainers();
            break;
          case "/tech-events":
            _swapContainers();
            $(".has-fadeout").removeClass("has-fadeout down-up");
            break;
          case "/tech-exports":
            _swapContainers();
            $(".has-fadeout").removeClass("has-fadeout down-up");
            break;
          case "/projects/corporate-governance":
            _swapContainers();
            $(".has-fadeout").removeClass("has-fadeout down-up");
            break;
          // the default case handles the generic page and china startup page
          default:
            _addAlternateSuccessMessage();
        }
      })

      .on("ajax:error", (e, xhr, data, error) => _addErrorMessage(xhr))
  };

  $(".email-lead").click(function (event) {
    var email = $("#email").val();
    $(this).parents('form').children('.output').css({ opacity: 1 })
    captureEmail(email);
  });
});
